import { Box, TextField, Typography } from '@mui/material';
import CustomDialog from 'components/custom-dialog/custom-dialog.component';
import FormError from 'components/form-error/form-error.component';
import Form from 'components/form/form.component';
import IncButton from 'components/inc-button/inc-button.component';
import TimerLink from 'components/timer-link/timer-link.component';
import React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  setGuestVerified,
  validateGuestVerificationCode,
} from 'redux/cart/cart.actions';
import { selectOrderId } from 'redux/cart/cart.selectors';

const GuestVerificationModal = ({
  open,
  onClose,
  maskedRecipient,
  expirationMinutes,
  onResend,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const orderId = useSelector(selectOrderId);

  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
    reset,
  } = useForm();

  const { ref, ...registerProps } = register('code', {
    required: t('checkout.guestVerification.codeRequired'),
    validate: value =>
      /^[0-9]{6}$/.test(value)
        ? true
        : t('checkout.guestVerification.invalidCodeError'),
  });

  const onSubmit = async ({ code }) => {
    const isValid = await dispatch(
      validateGuestVerificationCode(orderId, code),
    );
    if (isValid) {
      dispatch(setGuestVerified(true));
      reset();
      onClose();
    }
  };

  return (
    <CustomDialog
      open={open}
      close={onClose}
      title={t('checkout.guestVerification.modalTitle')}
      testId="GuestVerificationModal.Container"
    >
      <Typography variant="body2" mb={2}>
        {t('checkout.guestVerification.modalBody', {
          recipient: maskedRecipient,
          minutes: expirationMinutes,
        })}
      </Typography>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Box mb={1}>
          <TextField
            id="guest-verification-code"
            inputRef={ref}
            {...registerProps}
            fullWidth
            slotProps={{
              htmlInput: {
                inputMode: 'numeric',
                'aria-required': true,
                'aria-label': t(
                  'checkout.guestVerification.codeInput.ariaLabel',
                ),
              },
            }}
            autoComplete="one-time-code"
          />
          {errors.code && <FormError errorMessage={errors.code.message} />}
        </Box>
        <IncButton type="submit" disabled={isSubmitting} fullWidth>
          {t('checkout.guestVerification.submitButton')}
        </IncButton>
      </Form>
      <TimerLink
        expiry={30}
        onClick={onResend}
        label={t('verifyCode.resendCode')}
      />
    </CustomDialog>
  );
};

export default GuestVerificationModal;
